import React, {Component} from "react";
import {Buffer} from "buffer";
import {Card, Spin, Col, Row, Tabs, Timeline, Empty, Image, Button, Tag, Tooltip, Modal, Divider, Collapse} from "antd";
import {offerApiServices} from "../../services/offer/OfferApiService";
import currencyFormat from "../../helper/currencyFormat";
import {
    CheckCircleTwoTone,
    ClockCircleOutlined,
    FolderOpenOutlined,
    WarningOutlined,
    FilePdfOutlined
} from "@ant-design/icons";
import axios from "axios";
import ChatHistory from "../../components/ideal/ChatHistory";
import DetailCashbackAgent from "../../components/cashback-agent/DetailCashbackAgent";
import moment from "moment";
import Cookies from "universal-cookie";
import {catalogAreaServices} from "../../services/catalog/CatalogAreaService";
import DetailPrebooking from "./DetailPrebooking";
import CustomerDataView from "../customer/CustomerDataView";

const {Panel} = Collapse;

class DetailOffer extends Component<any, any> {
    private readonly initState!: any;
    private user = JSON.parse(Buffer.from(new Cookies().get("_u"), "base64").toString());

    constructor(props: any) {
        super(props);
        this.initState = {
            companyCode: "",
            offerCode: "",
            dataDetailStock: {},
            fetchingDetailOffer: false,
            fetchPaymentHistory: false,
            dataPaymentHistory: [],
            totalPayment: 0,
            fetchingPo: false,
            modalPo: false,
            dataPo: {},
            fetchCatalogueProcess: true,
            otrCatalogueDifferent: false,
            otrCatalogueShow: false,
            otrCatalogue: 0,
            urlImageCatalogue: "",
            phoneNumberOwner: "",
            phoneNumberAlternative_owner: "",
            phoneNumberOrderMaker: "",
            showModalPrebooking: false,
            chosenPrebookingCode: "",
        };
        this.state = {...this.initState};
    }

    async componentDidMount() {
        await this.promisedSetState({
            offerCode: this.props.offerCode,
            companyCode: this.props.companyCode,
            fetchingDetailOffer: true,
        });

        await this.showOfferDetail();
        this.getPayment();
    }

    async componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) {
        if (this.props.offerCode !== prevProps.offerCode) {
            await this.promisedSetState({
                offerCode: this.props.offerCode,
                companyCode: this.props.companyCode,
                fetchingDetailOffer: true,
            });
        }

        if (this.props.companyCode !== prevProps.companyCode) {
            await this.promisedSetState({
                offerCode: this.props.offerCode,
                companyCode: this.props.companyCode,
                fetchingDetailOffer: true,
            });
        }

        if (this.props.time !== prevProps.time) {
            this.getPayment();
            await this.showOfferDetail();
        }
    }

    showOfferDetail = async () => {
        await offerApiServices
            .getDetailOffer({
                offerCode: this.state.offerCode,
                companyCode: this.state.companyCode,
            })
            .then(async (value) => {
                await this.promisedSetState({
                    dataDetailStock: value.data.data,
                    fetchingDetailOffer: false,
                    phoneNumberOwner:
                        value.data.data?.contact?.phone_number_owner.substring(0, 2) === "08"
                            ? value.data.data?.contact?.phone_number_owner.replace(/^.{2}/g, "628")
                            : value.data.data?.contact?.phone_number_owner,
                    phoneNumberAlternative_owner:
                        value.data.data?.contact?.phone_number_alternative_owner.substring(0, 2) === "08"
                            ? value.data.data?.contact?.phone_number_alternative_owner.replace(/^.{2}/g, "628")
                            : value.data.data?.contact?.phone_number_alternative_owner,
                    phoneNumberOrderMaker:
                        value.data.data?.contact?.phone_number_order_maker.substring(0, 2) === "08"
                            ? value.data.data?.contact?.phone_number_order_maker.replace(/^.{2}/g, "628")
                            : value.data.data?.contact?.phone_number_order_maker,
                });
                const sleep = (waitTimeInMs: number) => new Promise((resolve) => setTimeout(resolve, waitTimeInMs));
                await sleep(100);
                await this.fetchCatalogueVariant();
            })
            .catch(async (reason) => {
                await this.promisedSetState({
                    dataDetailStock: {},
                    fetchingDetailOffer: false,
                    phoneNumberOwner: "",
                    phoneNumberAlternative_owner: "",
                    phoneNumberOrderMaker: "",
                });
            });
    };

    fetchCatalogueVariant = async () => {
        await this.promisedSetState({
            fetchCatalogueProcess: true,
            otrCatalogueDifferent: false,
            otrCatalogueShow: false,
            otrCatalogue: 0,
        });
        try {
            await catalogAreaServices
                .getCatalogVariant({
                    companyCode: this.state.companyCode,
                    areaCode: this.state.dataDetailStock?.area,
                    variantCode: this.state.dataDetailStock?.vehicle?.variant_code,
                })
                .then(async (dataVariantHome) => {
                    let urlImage = "";
                    const tempVariantCopan = dataVariantHome?.data?.data;
                    for (const element of tempVariantCopan ?? []) {
                        if (element?.color_code?.toUpperCase() === this.state.dataDetailStock?.vehicle?.color_code?.toUpperCase()) {
                            urlImage = element?.url_image;
                        }
                    }

                    let tempCatalogueDifferent = this.state.dataDetailStock?.price_and_bill?.otr !== dataVariantHome?.data?.meta?.Price;
                    await this.promisedSetState({
                        fetchCatalogueProcess: false,
                        otrCatalogueDifferent: tempCatalogueDifferent,
                        otrCatalogueShow: true,
                        otrCatalogue: dataVariantHome?.data?.meta?.Price,
                        urlImageCatalogue: urlImage,
                    });
                });
        } catch (e: any) {
            console.log(e);
            await this.promisedSetState({
                fetchCatalogueProcess: false,
                otrCatalogueDifferent: false,
                otrCatalogueShow: true,
                otrCatalogue: 0,
            });
        }
    };

    getPayment = async () => {
        await this.promisedSetState({
            fetchPaymentHistory: true,
        });

        offerApiServices
            .getPaymentHistoryOffer({
                offerCode: this.state.offerCode,
            })
            .then((dataFetchPaymentHistory) => {
                const paymentHistory = dataFetchPaymentHistory.data.data
                paymentHistory.sort((a: { timestamp: string }, b: { timestamp: string }) =>
                    new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime()
                );

                let totalPayment = 0
                for (const item of paymentHistory) {
                    totalPayment += Number(item.amount)
                }

                this.setState({
                    totalPayment: totalPayment,
                    fetchPaymentHistory: false,
                    dataPaymentHistory: paymentHistory,
                });
            })
            .catch((e) => {
                this.setState({
                    totalPayment: 0,
                    fetchPaymentHistory: false,
                    dataPaymentHistory: [],
                });
            });
    };

    fetchPo = async (version: string) => {
        this.setState({
            modalPo: true,
            fetchingPo: true,
        });

        let params = {};
        if (version === "v1") {
            params = {
                leasingCode: this.state.dataDetailStock?.credit?.finco_code?.toUpperCase(),
                trackNumber: this.state.dataDetailStock?.credit?.po_track_number,
            };
        }
        if (version === "v2") {
            params = {
                poNumber: this.state.dataDetailStock?.credit?.po_code?.toUpperCase(),
            };
        }

        await axios({
            method: "get",
            url: "https://asia-southeast2-amh-b2b.cloudfunctions.net/api-b2b/public/fetch-track-number",
            params: params,
            timeout: 100000000000,
            headers: {"Content-Type": "application/json"},
        })
            .then((response) => {
                this.setState({
                    fetchingPo: false,
                    dataPo: response.data?.data,
                });
                console.log(response);
            })
            .catch((response) => {
                this.setState({
                    fetchingPo: false,
                    dataPo: {
                        error: "error",
                    },
                });
            });
    };

    showPrebookingDetail = async (preBookingCode: any) => {
        this.setState({
            showModalPrebooking: true,
            chosenPrebookingCode: preBookingCode,
        });
    };

    onPropsChat = (data: any) => {
        this.showOfferDetail();
    };

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    render() {
        const listPromoUsedName = [];
        for (const item of this.state.dataDetailStock?.detail_promo ?? []) {
            listPromoUsedName.push(item?.code);
        }

        const shipOrder = this.state.dataDetailStock?.additional_cost_data?.take_in_dealer_data
            ? currencyFormat(0)
            : currencyFormat(Number(this.state.dataDetailStock?.additional_cost_data?.bpdeab) + Number(this.state.dataDetailStock?.additional_cost_data?.bpdead));
        let additionalCost = "";
        if (this.state.dataDetailStock?.additional_cost_data?.take_in_dealer_data) {
            additionalCost = currencyFormat(
                Number(this.state.dataDetailStock?.additional_cost_data?.pelwil) +
                Number(this.state.dataDetailStock?.additional_cost_data?.pdi) +
                Number(this.state.dataDetailStock?.additional_cost_data?.difference_otr)
            );
        } else {
            additionalCost = currencyFormat(
                Number(this.state.dataDetailStock?.additional_cost_data?.pelwil) +
                Number(this.state.dataDetailStock?.additional_cost_data?.bpkon) +
                Number(this.state.dataDetailStock?.additional_cost_data?.tol) +
                Number(this.state.dataDetailStock?.additional_cost_data?.difference_otr)
            );
        }

        return (
            <React.Fragment>
                <div style={this.state.fetchingDetailOffer ? {} : {display: "none"}} className={`spinCenter`}>
                    <Spin size="large"/>
                </div>
                <Tabs style={!this.state.fetchingDetailOffer ? {} : {display: "none"}} defaultActiveKey="1">
                    <Tabs.TabPane tab="Offer" key="1">
                        <Row>
                            <Col xs={24} xl={12} style={{padding: 10}}>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Kode Offer:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailStock?.transaction_code}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Tanggal Offer:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailStock?.transaction_time?.replace("T", " ")?.substring(0, 19)}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}
                                     style={this.state.dataDetailStock?.purchase_method === "credit" ? {} : {display: "none"}}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Tanggal Masuk B2B:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailStock?.survey_created_time?.replace("T", " ")?.substring(0, 19)}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}
                                     style={this.state.dataDetailStock?.purchase_method === "credit" && this.state.dataDetailStock?.tracking_code ? {} : {display: "none"}}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Tracking Code B2B:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailStock?.tracking_code ?? "-"}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Sumber:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailStock?.source}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Metode Pembelian:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailStock?.purchase_method}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Area:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailStock?.area?.toUpperCase()}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Kode Deal:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailStock?.deal_code?.toUpperCase()}
                                    </Col>
                                </Row>
                                <Divider/>
                                <span style={this.state.dataDetailStock?.amarta_vip_uid ? {} : {display: "none"}}>
                  <CheckCircleTwoTone twoToneColor="#52c41a"/>
                                    &nbsp;<i
                                    style={{fontSize: "85%", color: "#52c41a"}}>Login with AmartaVip account</i>
                </span>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Kode Agen:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailStock?.agent_code}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Nama Agen:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailStock?.agent_name?.toUpperCase() ?? "-"}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Type User AmartaVip:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailStock?.amarta_vip_type?.toUpperCase() ?? "-"}
                                    </Col>
                                </Row>
                                <div style={this.state.dataDetailStock?.mediator_code ? {} : {display: "none"}}>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Kode Mediator:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {this.state.dataDetailStock?.mediator_code}
                                        </Col>
                                    </Row>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Nama Mediator:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {this.state.dataDetailStock?.mediator_name?.toUpperCase() ?? "-"}
                                        </Col>
                                    </Row>
                                </div>
                                <Divider/>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Nomor KTP Pemilik:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailStock?.id_card_owner?.id_card_number}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Nama Pemilik:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailStock?.id_card_owner?.full_name?.toUpperCase()}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Nomor Telpon Pemilik:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailStock?.contact?.phone_number_owner}
                                        {this.state.dataDetailStock?.contact?.phone_number_wa_available_owner ? (
                                            <Tooltip title="Whatsapp Aktif ">
                                                &nbsp;
                                                <CheckCircleTwoTone twoToneColor="#52c41a"/>
                                            </Tooltip>
                                        ) : null}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Nomor KTP Pemesan:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailStock?.id_card_order_maker?.id_card_number}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Nama Pemesan:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailStock?.id_card_order_maker?.full_name?.toUpperCase()}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Nomor Telpon Pemesan:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailStock?.contact?.phone_number_order_maker}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Catatan Offer:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailStock?.notes ?? ""}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}
                                     style={this.state.dataDetailStock?.stock_code ? {} : {display: "none"}}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Book Kode Stock:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailStock?.stock_code ?? ""}
                                    </Col>
                                </Row>
                                <br/>
                                <Row className={`pt-5`}
                                     style={this.state.dataDetailStock?.stock_number ? {} : {display: "none"}}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`} style={{color: "#cc0d0d"}}>
                                        <i>Book Nomor Mesin:</i>
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailStock?.stock_number ?? ""}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}
                                     style={this.state.dataDetailStock?.stock_closing_date ? {} : {display: "none"}}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`} style={{color: "#cc0d0d"}}>
                                        <i>Tanggal Minimal Pemenuhan:</i>
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailStock?.stock_closing_date?.substring(0, 10) ?? ""}
                                    </Col>
                                </Row>
                                <br/>

                                <div
                                    style={this.state.dataDetailStock?.offer_status === "OPEN" ? {} : {display: "none"}}>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Status Offer:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            <b>
                                                <Tag color="processing">{this.state.dataDetailStock?.offer_status}</Tag>
                                            </b>
                                        </Col>
                                    </Row>
                                </div>

                                <div
                                    style={this.state.dataDetailStock?.offer_status === "ORDER" ? {} : {display: "none"}}>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Status Offer:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            <b>
                                                <Tag color="processing">{this.state.dataDetailStock?.offer_status}</Tag>
                                            </b>
                                        </Col>
                                    </Row>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Order Code:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {this.state.dataDetailStock?.order_code}
                                        </Col>
                                    </Row>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Order Time:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {this.state.dataDetailStock?.order_time}
                                        </Col>
                                    </Row>
                                </div>

                                <div
                                    style={this.state.dataDetailStock?.offer_status === "CANCEL" ? {} : {display: "none"}}>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Status Offer:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            <b>
                                                <Tag color="error">{this.state.dataDetailStock?.offer_status}</Tag>
                                            </b>
                                        </Col>
                                    </Row>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Alasan Cancel:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {this.state.dataDetailStock?.cancel_reason}
                                        </Col>
                                    </Row>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Cancel Time:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {this.state.dataDetailStock?.cancel_order_time}
                                        </Col>
                                    </Row>
                                </div>

                                <Row className={`pt-15`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        QC Admin:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailStock?.qc_admin ?? "-"}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        QC Time:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailStock?.qc_time?.replace("T", " ")?.substring(0, 19) ?? "-"}
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={24} xl={12} style={{padding: 10}}>
                                <div
                                    style={this.state.dataDetailStock?.prebooking_data?.prebooking_code ? {} : {display: "none"}}>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Kode Prebooking:
                                        </Col>
                                        <Col xs={24} xl={18}>
                      <span className={`font-90-link`}
                            onClick={(event) => this.showPrebookingDetail(this.state.dataDetailStock?.prebooking_data?.prebooking_code)}>
                        {this.state.dataDetailStock?.prebooking_data?.prebooking_code}
                      </span>
                                        </Col>
                                    </Row>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Kode Deposit:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {this.state.dataDetailStock?.prebooking_data?.deposit_code ?? "-"}
                                        </Col>
                                    </Row>
                                    <Divider/>
                                </div>

                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Brand:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailStock?.vehicle?.brand_name}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Model:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailStock?.vehicle?.model_name}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Kode Variant:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailStock?.vehicle?.variant_code}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Variant:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailStock?.vehicle?.variant_name}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Kode / Nama Warna:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailStock?.vehicle?.color_code} - {this.state.dataDetailStock?.vehicle?.color_name}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Alternatif Warna:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        ({this.state.dataDetailStock?.vehicle?.alternative_color?.code})
                                        - {this.state.dataDetailStock?.vehicle?.alternative_color?.name}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Tahun Kendaraan:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailStock?.vehicle?.year}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Kode Indent:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailStock?.indent_code}
                                        {this.state.dataDetailStock?.indent_image && (
                                            <Image width={"20px"} src={this.state.dataDetailStock?.indent_image}/>
                                        )}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Tanggal Indent:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailStock?.indent_date}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Ambil Kendaraan di Dealer:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailStock?.take_vehicle_in_dealer ? "ya" : "tidak"}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}
                                     style={this.state.dataDetailStock?.order?.product ? {} : {display: "none"}}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Nosin Order:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailStock?.order?.product}
                                    </Col>
                                </Row>

                                <Divider/>

                                <div
                                    style={this.state.dataDetailStock?.purchase_method === "credit" ? {} : {display: "none"}}>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Kode Finco:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {this.state.dataDetailStock?.credit?.finco_code?.toUpperCase()}
                                        </Col>
                                    </Row>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Nama Finco:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {this.state.dataDetailStock?.credit?.finco_name?.toUpperCase()}
                                        </Col>
                                    </Row>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Branch Finco:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {this.state.dataDetailStock?.credit?.finco_branch_code}
                                        </Col>
                                    </Row>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            OTR:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {currencyFormat(this.state.dataDetailStock?.price_and_bill?.otr)}
                                            <span style={{fontSize: "80%", color: "gray", paddingLeft: 10}}>
                        OTR copan:
                        <span style={this.state.fetchCatalogueProcess ? {display: "none"} : {
                            fontSize: "85%",
                            paddingLeft: 7
                        }}>{currencyFormat(this.state.otrCatalogue)}</span>
                        <span style={!this.state.fetchCatalogueProcess ? {display: "none"} : {
                            fontSize: "85%",
                            paddingLeft: 7
                        }}>
                          <Spin/> Loading...
                        </span>
                        <span style={!this.state.otrCatalogueDifferent ? {display: "none"} : {
                            fontSize: "85%",
                            paddingLeft: 7
                        }}>
                          <Tooltip title="Nilai OTR Offer berbeda dengan OTR katalog" color={"red"}>
                            <WarningOutlined style={{color: "red", fontSize: "120%"}}/>
                          </Tooltip>
                        </span>
                      </span>
                                        </Col>
                                    </Row>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            DP:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {currencyFormat(this.state.dataDetailStock?.credit?.dp_amount)}
                                        </Col>
                                    </Row>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Finco Payment:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {currencyFormat(this.state.dataDetailStock?.price_and_bill?.otr - this.state.dataDetailStock?.credit?.dp_amount)}
                                        </Col>
                                    </Row>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Tenor:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {this.state.dataDetailStock?.credit?.tenor}
                                        </Col>
                                    </Row>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Cicilan:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {currencyFormat(this.state.dataDetailStock?.credit?.installment_amount)}
                                        </Col>
                                    </Row>

                                    <Divider/>

                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Track Number:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {this.state.dataDetailStock?.credit?.po_track_number}
                                        </Col>
                                    </Row>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Kode PO:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {this.state.dataDetailStock?.credit?.po_code?.toUpperCase()}
                                            {this.state.dataDetailStock?.credit?.po_code ? (
                                                <Tooltip title="Click untuk melihat data" color={"cyan"}>
                                                    <FolderOpenOutlined className={"small-avatar-link"}
                                                                        style={{fontSize: "110%", paddingLeft: 10}}
                                                                        onClick={(event) => this.fetchPo("v2")}/>
                                                </Tooltip>
                                            ) : null}
                                        </Col>
                                    </Row>

                                    <Collapse defaultActiveKey={["1"]} ghost>
                                        <Panel header="Detail PO" key="3">
                                            <Row className={`pt-5`}>
                                                <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                                    {" "}
                                                    &nbsp; &nbsp; Tanggal PO:
                                                </Col>
                                                <Col xs={24} xl={18}>
                                                    {this.state.dataDetailStock?.credit?.po_time?.substring(0, 10)}
                                                </Col>
                                            </Row>
                                            <Row className={`pt-5`}>
                                                <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                                    {" "}
                                                    &nbsp; &nbsp; Nomor Telpon PO:
                                                </Col>
                                                <Col xs={24} xl={18}>
                                                    {this.state.dataDetailStock?.credit?.po_phone_number}
                                                </Col>
                                            </Row>
                                            <Row className={`pt-5`}>
                                                <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                                    {" "}
                                                    &nbsp; &nbsp; Gambar PO:
                                                </Col>
                                                <Col xs={24} xl={18}>
                                                    {this.state.dataDetailStock?.credit?.po_image && (
                                                        <a target={"_blank"} rel="noreferrer"
                                                           href={this.state.dataDetailStock?.credit?.po_image}>
                                                            {" "}
                                                            Lihat Image{" "}
                                                        </a>
                                                    )}
                                                </Col>
                                            </Row>
                                            <Row className={`pt-5`}>
                                                <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                                    {" "}
                                                    &nbsp; &nbsp; Gambar Dokumen Cancel PO:
                                                </Col>
                                                <Col xs={24} xl={18}>
                                                    {this.state.dataDetailStock?.credit?.cancel_po_image && (
                                                        <a target={"_blank"} rel="noreferrer"
                                                           href={this.state.dataDetailStock?.credit?.cancel_po_image}>
                                                            {" "}
                                                            Lihat Image{" "}
                                                        </a>
                                                    )}
                                                </Col>
                                            </Row>
                                            <Row className={`pt-5`}>
                                                <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                                    {" "}
                                                    &nbsp; &nbsp; Kode Variant PO:
                                                </Col>
                                                <Col xs={24} xl={18}>
                                                    {this.state.dataDetailStock?.credit?.po_variant_code}
                                                </Col>
                                            </Row>
                                            <Row className={`pt-5`}>
                                                <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                                    {" "}
                                                    &nbsp; &nbsp; Nama Variant PO:
                                                </Col>
                                                <Col xs={24} xl={18}>
                                                    {this.state.dataDetailStock?.credit?.po_vehicle_name}
                                                </Col>
                                            </Row>
                                            <Row className={`pt-5`}>
                                                <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                                    {" "}
                                                    &nbsp; &nbsp; Tahun Kendaraan PO:
                                                </Col>
                                                <Col xs={24} xl={18}>
                                                    {this.state.dataDetailStock?.credit?.po_vehicle_year}
                                                </Col>
                                            </Row>
                                            <Row className={`pt-5`}>
                                                <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                                    {" "}
                                                    &nbsp; &nbsp; Nomor KTP Pemilik PO:
                                                </Col>
                                                <Col xs={24} xl={18}>
                                                    {this.state.dataDetailStock?.credit?.po_ownership_id_card_number}
                                                </Col>
                                            </Row>
                                            <Row className={`pt-5`}>
                                                <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                                    {" "}
                                                    &nbsp; &nbsp; Nama Pemilik PO:
                                                </Col>
                                                <Col xs={24} xl={18}>
                                                    {this.state.dataDetailStock?.credit?.po_ownership_full_name}
                                                </Col>
                                            </Row>
                                            <Row className={`pt-5`}>
                                                <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                                    {" "}
                                                    &nbsp; &nbsp; Nomor KTP Pemesan PO:
                                                </Col>
                                                <Col xs={24} xl={18}>
                                                    {this.state.dataDetailStock?.credit?.po_order_maker_id_card_number}
                                                </Col>
                                            </Row>
                                            <Row className={`pt-5`}>
                                                <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                                    {" "}
                                                    &nbsp; &nbsp; Nama Pemesan PO:
                                                </Col>
                                                <Col xs={24} xl={18}>
                                                    {this.state.dataDetailStock?.credit?.po_order_maker_full_name}
                                                </Col>
                                            </Row>
                                            <Row className={`pt-5`}>
                                                <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                                    Kebijakan Expire PO:
                                                </Col>
                                                <Col xs={24} xl={18}>
                                                    {this.state.dataDetailStock?.credit?.po_expire_policy} {this.state.dataDetailStock?.credit?.po_expire_poilicy}
                                                </Col>
                                            </Row>
                                            <Row className={`pt-5`}>
                                                <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                                    Expire PO:
                                                </Col>
                                                <Col xs={24} xl={18}>
                                                    {this.state.dataDetailStock?.credit?.po_expired_at}
                                                </Col>
                                            </Row>
                                            <Row className={`pt-5`}>
                                                <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                                    Catatan:
                                                </Col>
                                                <Col xs={24} xl={18}>
                                                    {this.state.dataDetailStock?.credit?.credit_note}
                                                </Col>
                                            </Row>
                                        </Panel>
                                    </Collapse>
                                </div>
                            </Col>
                        </Row>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="Data Tagihan" key="3">
                        <Row>
                            <Col xs={24} xl={12} style={{padding: 10}}>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        OTR:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {currencyFormat(this.state.dataDetailStock?.price_and_bill?.otr)}
                                        <span style={{fontSize: "80%", color: "gray", paddingLeft: 10}}>
                      OTR copan:
                      <span style={this.state.fetchCatalogueProcess ? {display: "none"} : {
                          fontSize: "85%",
                          paddingLeft: 7
                      }}>{currencyFormat(this.state.otrCatalogue)}</span>
                      <span style={!this.state.fetchCatalogueProcess ? {display: "none"} : {
                          fontSize: "85%",
                          paddingLeft: 7
                      }}>
                        <Spin/> Loading...
                      </span>
                      <span style={!this.state.otrCatalogueDifferent ? {display: "none"} : {
                          fontSize: "85%",
                          paddingLeft: 7
                      }}>
                        <Tooltip title="Nilai OTR Offer berbeda dengan OTR katalog" color={"red"}>
                          <WarningOutlined style={{color: "red", fontSize: "120%"}}/>
                        </Tooltip>
                      </span>
                    </span>
                                    </Col>
                                </Row>

                                <Row className={`pt-5`}
                                     style={this.state.dataDetailStock?.purchase_method === "credit" ? {} : {display: "none"}}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        DP:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {currencyFormat(this.state.dataDetailStock?.credit?.dp_amount)}
                                    </Col>
                                </Row>

                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Kode Promo:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {listPromoUsedName.toString()}
                                    </Col>
                                </Row>

                                <Divider style={{marginTop: 10, marginBottom: 10, marginRight: 20}}/>

                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={8} className={`col-grey-small-90`}>
                                        Discount Promo:
                                    </Col>
                                    <Col xs={24} xl={16}>
                                        {currencyFormat(this.state.dataDetailStock?.price_and_bill?.promo_discount)}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={8} className={`col-grey-small-90`}>
                                        Biaya Order:
                                    </Col>
                                    <Col xs={24} xl={16}>
                                        {currencyFormat(this.state.dataDetailStock?.price_and_bill?.order_fee)}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={8} className={`col-grey-small-90`}>
                                        Biaya Pembayaran:
                                    </Col>
                                    <Col xs={24} xl={16}>
                                        {currencyFormat(this.state.dataDetailStock?.price_and_bill?.payment_fee ?? 0)}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={8} className={`col-grey-small-90`}>
                                        Pre Booking:
                                    </Col>
                                    <Col xs={24} xl={16}>
                                        {currencyFormat(this.state.dataDetailStock?.price_and_bill?.prebooking_amount ?? 0)}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={8} className={`col-grey-small-90`}>
                                        Pre Deposit:
                                    </Col>
                                    <Col xs={24} xl={16}>
                                        {currencyFormat(this.state.dataDetailStock?.price_and_bill?.prebooking_deposit_amount ?? 0)}
                                    </Col>
                                </Row>

                                <Divider style={{marginTop: 10, marginBottom: 10, marginRight: 20}}/>

                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={8} className={`col-grey-small-90`}>
                                        <b style={{paddingLeft: 10}}>Total TagihanKonsumen:</b>
                                    </Col>
                                    <Col xs={24} xl={16}>
                                        <b>{currencyFormat(this.state.dataDetailStock?.price_and_bill?.total_bill)}</b>
                                    </Col>
                                </Row>

                                <Divider style={{marginTop: 10, marginBottom: 10, marginRight: 20}}/>

                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={8} className={`col-grey-small-90`}>
                                        Biaya Cashback Agent:
                                    </Col>
                                    <Col xs={24} xl={16}>
                                        {currencyFormat(this.state.dataDetailStock?.price_and_bill?.cashback_agent_fee)}
                                        <i style={{
                                            paddingLeft: "10px",
                                            color: "#a8a8a8",
                                            fontSize: "80%"
                                        }}>paid: {currencyFormat(this.state.dataDetailStock?.price_and_bill?.cashback_agent_fee_paid)}</i>
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={8} className={`col-grey-small-90`}>
                                        Biaya Platform:
                                    </Col>
                                    <Col xs={24} xl={16}>
                                        {currencyFormat(this.state.dataDetailStock?.price_and_bill?.platform_fee)}
                                    </Col>
                                </Row>

                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={8} className={`col-grey-small-90`}>
                                        Komisi Finco:
                                    </Col>
                                    <Col xs={24} xl={16}>
                                        {currencyFormat(this.state.dataDetailStock?.price_and_bill?.finco_commission)}
                                    </Col>
                                </Row>

                                <div>
                                    <Divider style={{marginTop: 10, marginBottom: 10, marginRight: 20}}/>
                                    <i style={{paddingLeft: "10px", color: "#a8a8a8", fontSize: "80%"}}> Type Biaya
                                        Tambahan </i>
                                    <b style={!this.state.dataDetailStock?.additional_cost_type_closing_changed ? {color: "#a8a8a8"} : {display: "none"}}>
                                        {this.state.dataDetailStock?.additional_cost_type === "BILL" ? "Bill" : "Invoice"}{" "}
                                    </b>
                                    <b style={this.state.dataDetailStock?.additional_cost_type_closing_changed ? {color: "#a8a8a8"} : {display: "none"}}>
                                        {" "}
                                        <s>
                                            <i>Bill</i>
                                        </s>{" "}
                                        Invoice
                                    </b>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={8} className={`col-grey-small-90`}>
                                            Biaya Pengiriman:
                                        </Col>
                                        <Col xs={24} xl={16}>
                                            {shipOrder === "RpNaN" ? "-" : shipOrder}
                                        </Col>
                                    </Row>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={8} className={`col-grey-small-90`}>
                                            Biaya Tambahan:
                                        </Col>
                                        <Col xs={24} xl={16}>
                                            {additionalCost === "RpNaN" ? "-" : additionalCost}
                                        </Col>
                                    </Row>

                                    <Collapse defaultActiveKey={["2"]} ghost>
                                        <Panel header="Detail Biaya Tambahan" key="4">
                                            <Row className={`pt-5`}>
                                                <Col xs={24} xl={8} className={`col-grey-small-90`}>
                                                    Perbedaan OTR:
                                                    <i style={{
                                                        paddingLeft: "10px",
                                                        color: "#a8a8a8",
                                                        fontSize: "80%"
                                                    }}>{this.state.dataDetailStock?.additional_cost_detail?.difference_otr?.toLowerCase()}</i>
                                                </Col>
                                                <Col xs={24} xl={16}>
                                                    {this.state.dataDetailStock?.additional_cost_data?.difference_otr ? currencyFormat(this.state.dataDetailStock?.additional_cost_data?.difference_otr) : "-"}
                                                </Col>
                                            </Row>
                                            <Row className={`pt-5`}>
                                                <Col xs={24} xl={8} className={`col-grey-small-90`}>
                                                    BPDEAB:
                                                    <i style={{
                                                        paddingLeft: "10px",
                                                        color: "#a8a8a8",
                                                        fontSize: "80%"
                                                    }}>{this.state.dataDetailStock?.additional_cost_detail?.bpdeab?.toLowerCase()}</i>
                                                </Col>
                                                <Col xs={24} xl={16}>
                                                    {this.state.dataDetailStock?.additional_cost_data?.bpdeab ? currencyFormat(this.state.dataDetailStock?.additional_cost_data?.bpdeab) : "-"}
                                                </Col>
                                            </Row>
                                            <Row className={`pt-5`}>
                                                <Col xs={24} xl={8} className={`col-grey-small-90`}>
                                                    BPDEAD:
                                                    <i style={{
                                                        paddingLeft: "10px",
                                                        color: "#a8a8a8",
                                                        fontSize: "80%"
                                                    }}>{this.state.dataDetailStock?.additional_cost_detail?.bpdead?.toLowerCase()}</i>
                                                </Col>
                                                <Col xs={24} xl={16}>
                                                    {this.state.dataDetailStock?.additional_cost_data?.bpdead ? currencyFormat(this.state.dataDetailStock?.additional_cost_data?.bpdead) : "-"}
                                                </Col>
                                            </Row>
                                            <Row className={`pt-5`}>
                                                <Col xs={24} xl={8} className={`col-grey-small-90`}>
                                                    PELWIL:
                                                    <i style={{
                                                        paddingLeft: "10px",
                                                        color: "#a8a8a8",
                                                        fontSize: "80%"
                                                    }}>{this.state.dataDetailStock?.additional_cost_detail?.pelwil?.toLowerCase()}</i>
                                                </Col>
                                                <Col xs={24} xl={16}>
                                                    {this.state.dataDetailStock?.additional_cost_data?.pelwil ? currencyFormat(this.state.dataDetailStock?.additional_cost_data?.pelwil) : "-"}
                                                </Col>
                                            </Row>
                                            <Row className={`pt-5`}>
                                                <Col xs={24} xl={8} className={`col-grey-small-90`}>
                                                    BPKON:
                                                    <i style={{
                                                        paddingLeft: "10px",
                                                        color: "#a8a8a8",
                                                        fontSize: "80%"
                                                    }}>{this.state.dataDetailStock?.additional_cost_detail?.bpkon?.toLowerCase()}</i>
                                                </Col>
                                                <Col xs={24} xl={16}>
                                                    {this.state.dataDetailStock?.additional_cost_data?.bpkon ? currencyFormat(this.state.dataDetailStock?.additional_cost_data?.bpkon) : "-"}
                                                </Col>
                                            </Row>
                                            <Row className={`pt-5`}>
                                                <Col xs={24} xl={8} className={`col-grey-small-90`}>
                                                    PDI:
                                                    <i style={{
                                                        paddingLeft: "10px",
                                                        color: "#a8a8a8",
                                                        fontSize: "80%"
                                                    }}>{this.state.dataDetailStock?.additional_cost_detail?.pdi?.toLowerCase()}</i>
                                                </Col>
                                                <Col xs={24} xl={16}>
                                                    {this.state.dataDetailStock?.additional_cost_data?.pdi ? currencyFormat(this.state.dataDetailStock?.additional_cost_data?.pdi) : "-"}
                                                </Col>
                                            </Row>
                                            <Row className={`pt-5`}>
                                                <Col xs={24} xl={8} className={`col-grey-small-90`}>
                                                    TOL:
                                                    <i style={{
                                                        paddingLeft: "10px",
                                                        color: "#a8a8a8",
                                                        fontSize: "80%"
                                                    }}>{this.state.dataDetailStock?.additional_cost_detail?.tol?.toLowerCase()}</i>
                                                </Col>
                                                <Col xs={24} xl={16}>
                                                    {this.state.dataDetailStock?.additional_cost_data?.tol ? currencyFormat(this.state.dataDetailStock?.additional_cost_data?.tol) : "-"}
                                                </Col>
                                            </Row>
                                            <Row className={`pt-5`}>
                                                <Col xs={24} xl={8} className={`col-grey-small-90`}>
                                                    Biaya Biro Jasa:
                                                    <i style={{
                                                        paddingLeft: "10px",
                                                        color: "#a8a8a8",
                                                        fontSize: "80%"
                                                    }}>{this.state.dataDetailStock?.additional_cost_detail?.bureau_fee?.toLowerCase()}</i>
                                                </Col>
                                                <Col xs={24} xl={16}>
                                                    {this.state.dataDetailStock?.additional_cost_data?.bureau_fee ? currencyFormat(this.state.dataDetailStock?.additional_cost_data?.bureau_fee) : "-"}
                                                </Col>
                                            </Row>
                                            <Row className={`pt-5`}>
                                                <Col xs={24} xl={8} className={`col-grey-small-90`}>
                                                    Ambil Kendaraan di Dealer:
                                                </Col>
                                                <Col xs={24} xl={16}>
                                                    {this.state.dataDetailStock?.additional_cost_data?.take_in_dealer_data ? "ya" : "tidak"}
                                                </Col>
                                            </Row>
                                        </Panel>
                                    </Collapse>
                                </div>

                                <Divider style={{marginTop: 10, marginBottom: 10, marginRight: 20}}/>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={8} className={`col-grey-small-90`}>
                                        <b style={{paddingLeft: 10}}>Total Transaksi:</b>
                                    </Col>
                                    <Col xs={24} xl={16}>
                                        <b>{currencyFormat(this.state.dataDetailStock?.price_and_bill?.total_transaction)}</b>
                                    </Col>
                                </Row>
                                <Divider style={{marginTop: 10, marginBottom: 10, marginRight: 20}}/>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={8} className={`col-grey-small-90`}>
                                        Discount PO Finco:
                                    </Col>
                                    <Col xs={24} xl={16}>
                                        {currencyFormat(this.state.dataDetailStock?.price_and_bill?.promo_finco_discount ? this.state.dataDetailStock?.price_and_bill?.promo_finco_discount : 0)}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}
                                     style={this.state.dataDetailStock?.purchase_method === "credit" ? {} : {display: "none"}}>
                                    <Col xs={24} xl={8} className={`col-grey-small-90`}>
                                        Nilai PK <i style={{paddingLeft: "5px", color: "#a8a8a8", fontSize: "80%"}}>*piutang
                                        kendaraan</i>
                                    </Col>
                                    <Col xs={24} xl={16}>
                                        {currencyFormat((this.state.dataDetailStock?.price_and_bill?.otr) - (this.state.dataDetailStock?.credit?.dp_amount || 0) - (this.state.dataDetailStock?.price_and_bill?.promo_finco_discount || 0))}
                                    </Col>
                                </Row>
                                <Divider style={{marginTop: 10, marginBottom: 10, marginRight: 20}}/>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={8} className={`col-grey-small-90`}>
                                        Refund Deduction:
                                    </Col>
                                    <Col xs={24} xl={16}>
                                        {currencyFormat(this.state.dataDetailStock?.refund_deduction ? this.state.dataDetailStock?.refund_deduction : 0)}
                                        <i style={{
                                            paddingLeft: "10px",
                                            color: "#a8a8a8",
                                            fontSize: "80%"
                                        }}> *Pengurangan Nilai Refund </i>
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={24} xl={12}>
                                <Row className={`pt-5`}>
                                    <Col span={9} className={`col-grey-small-90`}>
                                        Kode Bill:
                                    </Col>
                                    <Col span={15}>{this.state.dataDetailStock?.price_and_bill?.bill_code}</Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col span={9} className={`col-grey-small-90`}>
                                        Total Tagihan Konsumen:
                                    </Col>
                                    <Col
                                        span={15}>{currencyFormat(this.state.dataDetailStock?.price_and_bill?.total_bill)}</Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col span={9} className={`col-grey-small-90`}>
                                        Settlement Due Date:
                                    </Col>
                                    <Col span={15}>
                                        {this.state.dataDetailStock?.settlement_due_date ?? 0} days at{" "}
                                        {moment(this.state.dataDetailStock?.transaction_time?.substring(0, 10))
                                            .add(this.state.dataDetailStock?.settlement_due_date ?? 0, "days")
                                            .format("YYYY-MM-DD")}{" "}
                                    </Col>
                                </Row>
                                <br/>
                                <Row className={`pt-5`}>
                                    <Col span={9} className={`col-grey-small-90`}>
                                        Channel Transaksi Tanda Jadi:
                                    </Col>
                                    <Col span={15}>{this.state.dataDetailStock?.payment?.deposit_channel}</Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col span={9} className={`col-grey-small-90`}>
                                        Metode Pembayaran Tanda Jadi:
                                    </Col>
                                    <Col span={15}>{this.state.dataDetailStock?.payment?.deposit_method}</Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col span={9} className={`col-grey-small-90`}>
                                        Kode Pembayaran Tanda Jadi:
                                    </Col>
                                    <Col span={15}>{this.state.dataDetailStock?.payment?.deposit_code}</Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col span={9} className={`col-grey-small-90`}>
                                        Catatan Tanda Jadi:
                                    </Col>
                                    <Col span={15}>{this.state.dataDetailStock?.payment?.deposit_note}</Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col span={9} className={`col-grey-small-90`}>
                                        Nilai Tanda Jadi:
                                    </Col>
                                    <Col
                                        span={15}>{currencyFormat(this.state.dataDetailStock?.price_and_bill?.deposit_amount)}</Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col span={9} className={`col-grey-small-90`}>
                                        Tgl Tagihan Tanda Jadi:
                                    </Col>
                                    <Col span={15}>{this.state.dataDetailStock?.payment?.deposit_time}</Col>
                                </Row>
                                <br/>
                                <Row className={`pt-5`}>
                                    <Col span={9} className={`col-grey-small-90`}>
                                        Channel Transaksi Pelunasan:
                                    </Col>
                                    <Col span={15}>{this.state.dataDetailStock?.payment?.settlement_channel}</Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col span={9} className={`col-grey-small-90`}>
                                        Metode Pembayaran Pelunasan:
                                    </Col>
                                    <Col span={15}>{this.state.dataDetailStock?.payment?.settlement_method}</Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col span={9} className={`col-grey-small-90`}>
                                        Kode Pembayaran Pelunasan:
                                    </Col>
                                    <Col span={15}>{this.state.dataDetailStock?.payment?.settlement_code}</Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col span={9} className={`col-grey-small-90`}>
                                        Catatan Pelunasan:
                                    </Col>
                                    <Col span={15}>{this.state.dataDetailStock?.payment?.settlement_note}</Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col span={9} className={`col-grey-small-90`}>
                                        Nilai Pelunasan:
                                    </Col>
                                    <Col
                                        span={15}>{currencyFormat(this.state.dataDetailStock?.price_and_bill?.total_bill - this.state.dataDetailStock?.price_and_bill?.deposit_amount)}</Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col span={9} className={`col-grey-small-90`}>
                                        Tgl Tagihan Pelunasan:
                                    </Col>
                                    <Col span={15}>{this.state.dataDetailStock?.payment?.settlement_time}</Col>
                                </Row>
                            </Col>
                        </Row>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="Data Pembayaran" key="pay">
                        <div style={this.state.fetchPaymentHistory ? {
                            textAlign: "center",
                            padding: 20,
                            minHeight: 200
                        } : {display: "none"}}>
                            <Spin style={{marginTop: 20}} size={"large"} tip="Loading..."/>
                        </div>
                        <div style={!this.state.fetchPaymentHistory ? {} : {display: "none"}}>
                            <div style={this.state.dataPaymentHistory.length > 0 ? {} : {display: "none"}}>
                                <Button size={"small"} onClick={this.getPayment} type="primary">
                                    <ClockCircleOutlined/> Reload Data Pembayaran
                                </Button>
                                &nbsp;
                                <a
                                    target={"_blank"}
                                    rel={"noreferrer"}
                                    href={`https://asia-southeast1-autotrimitra.cloudfunctions.net/api-offer-otodis--create-pdf/spk/generate-payment?company=${this.state.companyCode}&offer_code=${this.state.dataDetailStock?.transaction_code}&admin_name=${this.user}&force_download=true`}
                                >
                                    <Button size={"small"} onClick={this.getPayment} type="primary">
                                        <FilePdfOutlined/> Bukti Pembayaran
                                    </Button>
                                </a>
                                <br/> <br/>

                                <div>
                                    <span className={`col-grey-small-90`}><i>Total Tagihan Konsumen</i></span><br/>
                                    <span>{currencyFormat(this.state.dataDetailStock?.price_and_bill?.total_bill)}</span><br/>
                                </div>
                                <div style={{marginTop: 10}}>
                                    <span className={`col-grey-small-90`}><i>Total Pembayaran</i></span><br/>
                                    <span><b>{currencyFormat(this.state.totalPayment)}</b></span>
                                </div>

                                <Divider/>

                                <div style={{marginLeft: 20}}>
                                    <Timeline>
                                        {this.state.dataPaymentHistory.map((dt: any, x: number) => (
                                            <Timeline.Item key={x}
                                                           dot={<ClockCircleOutlined style={{fontSize: "16px"}}/>}>
                                                <i style={{
                                                    fontSize: "85%",
                                                    color: "#59c997"
                                                }}>{dt.timestamp?.replace("T", " ").substring(0, 16)}</i>
                                                <br/>
                                                {dt.institution_type} {dt.institution_name}
                                                <br/>
                                                {dt.payload?.Reference}
                                                <br/>
                                                {currencyFormat(dt.amount)}
                                                <br/>
                                            </Timeline.Item>
                                        ))}
                                    </Timeline>
                                </div>
                            </div>
                            <div style={this.state.dataPaymentHistory.length === 0 ? {} : {display: "none"}}>
                                <Button size={"small"} onClick={this.getPayment} type="primary">
                                    <ClockCircleOutlined/> Reload Data Pembayaran
                                </Button>{" "}
                                <br/> <br/> <br/>
                                <Empty/>
                            </div>
                        </div>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="Cashback Agent" key="9">
                        <DetailCashbackAgent time={Math.floor(+new Date() / 1000)}
                                             offerCode={this.state.dataDetailStock?.transaction_code}/>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="Data Konsumen" key="customer">
                        <Row>
                            <Col xl={12} lg={12} md={24} sm={24} xs={24}>
                                <Card style={{marginLeft: 20, marginRight: 20, marginTop: 10}} size="small"
                                      hoverable={true}>
                                    Data Pemilik
                                    <Divider style={{marginTop: 10, marginBottom: 10}}/>
                                    <CustomerDataView
                                        idCard={this.state?.dataDetailStock?.id_card_owner}
                                        address={this.state.dataDetailStock?.address_owner}
                                        phoneNumber={this.state.dataDetailStock?.contact?.phone_number_owner}
                                        phoneNumberWaAvailable={this.state.dataDetailStock?.contact?.phone_number_wa_available_owner}
                                        alternativePhoneNumber={this.state.dataDetailStock?.contact?.phone_number_alternative_owner}
                                    />
                                </Card>
                            </Col>
                            <Col xl={12} lg={12} md={24} sm={24} xs={24}>
                                <Card style={{marginLeft: 20, marginRight: 20, marginTop: 10}} size="small"
                                      hoverable={true}>
                                    Kartu Keluarga
                                    <Divider style={{marginTop: 10, marginBottom: 10}}/>
                                    <Row>
                                        <Col xs={24} xl={12}>
                                            <Row className={`pt-5`}>
                                                <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                                    Nomor KK:
                                                </Col>
                                                <Col xs={24} xl={18}>
                                                    {this.state.dataDetailStock?.family_register_owner?.family_register_number}
                                                </Col>
                                            </Row>
                                            <Row className={`pt-5`}>
                                                <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                                    Relasi Pemilik:
                                                </Col>
                                                <Col xs={24} xl={18}>
                                                    {this.state.dataDetailStock?.family_register_owner?.relation_owner}
                                                </Col>
                                            </Row>
                                            <Row className={`pt-5`}>
                                                <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                                    Relasi Pemesan:
                                                </Col>
                                                <Col xs={24} xl={18}>
                                                    {this.state.dataDetailStock?.family_register_owner?.relation_order_maker}
                                                </Col>
                                            </Row>
                                            <Row className={`pt-5`}>
                                                <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                                    Edukasi Pemilik:
                                                </Col>
                                                <Col xs={24} xl={18}>
                                                    {this.state.dataDetailStock?.family_register_owner?.last_education_owner}
                                                </Col>
                                            </Row>
                                            <Row className={`pt-5`}>
                                                <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                                    Edukasi Pemesan:
                                                </Col>
                                                <Col xs={24} xl={18}>
                                                    {this.state.dataDetailStock?.family_register_owner?.last_education_order_maker}
                                                </Col>
                                            </Row>
                                            <Row className={`pt-5`}>
                                                <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                                    Gambar KK:
                                                </Col>
                                                <Col xs={24} xl={18}>
                                                    {this.state.dataDetailStock?.family_register_owner?.family_register_image && (
                                                        <a target={"_blank"} rel="noreferrer"
                                                           href={this.state.dataDetailStock?.family_register_owner?.family_register_image}>
                                                            {" "}
                                                            Lihat Image{" "}
                                                        </a>
                                                    )}
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                            <Col xl={12} lg={12} md={24} sm={24} xs={24}>
                                <Card style={{marginLeft: 20, marginRight: 20, marginTop: 10}} size="small"
                                      hoverable={true}>
                                    Data Pemesan
                                    <Divider style={{marginTop: 10, marginBottom: 10}}/>
                                    <CustomerDataView
                                        idCard={this.state?.dataDetailStock?.id_card_order_maker}
                                        address={this.state.dataDetailStock?.address_order_maker}
                                        phoneNumber={this.state.dataDetailStock?.contact?.phone_number_order_maker}
                                        phoneNumberWaAvailable={this.state.dataDetailStock?.contact?.phone_number_wa_available_order_maker}
                                        alternativePhoneNumber={this.state.dataDetailStock?.contact?.phone_number_alternative_order_maker}
                                    />
                                </Card>
                            </Col>
                            <Col xl={12} lg={12} md={24} sm={24} xs={24}>
                                <Card style={{marginLeft: 20, marginRight: 20, marginTop: 10}} size="small"
                                      hoverable={true}>
                                    Data Penjamin
                                    <Divider style={{marginTop: 10, marginBottom: 10}}/>
                                    <CustomerDataView
                                        idCard={this.state?.dataDetailStock?.id_card_guarantor}
                                        address={this.state.dataDetailStock?.address_guarantor}
                                        phoneNumber={this.state.dataDetailStock?.contact?.phone_number_guarantor}
                                        phoneNumberWaAvailable={this.state.dataDetailStock?.contact?.phone_number_wa_available_guarantor}
                                        alternativePhoneNumber={this.state.dataDetailStock?.contact?.phone_number_alternative_guarantor}
                                    />
                                </Card>
                            </Col>
                        </Row>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="Data Pengiriman" key="2">
                        <Row>
                            <Col xl={12} lg={12} md={24} sm={24} xs={24}>
                                <Card style={{marginLeft: 20, marginRight: 20, marginTop: 10}} size="small"
                                      hoverable={true}>
                                    Alamat Pengiriman
                                    <Divider style={{marginTop: 10, marginBottom: 10}}/>
                                    <Row className={`pt-5`}
                                         style={this.state.dataDetailStock?.take_vehicle_in_dealer ? {} : {display: "none"}}>
                                        <Col xs={24} xl={24}>
                                            *Konsumen Memilih mengambil kendaraan di dealer <br/>
                                            <br/>
                                        </Col>
                                    </Row>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Provinsi:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {this.state.dataDetailStock?.address_shipping?.province_name
                                                ? this.state.dataDetailStock?.address_shipping?.province_name
                                                : this.state.dataDetailStock?.address_owner?.province_name}
                                        </Col>
                                    </Row>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Kota:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {this.state.dataDetailStock?.address_shipping?.city_name ? this.state.dataDetailStock?.address_shipping?.city_name : this.state.dataDetailStock?.address_owner?.city_name}
                                        </Col>
                                    </Row>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Kecamatan:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {this.state.dataDetailStock?.address_shipping?.district_name
                                                ? this.state.dataDetailStock?.address_shipping?.district_name
                                                : this.state.dataDetailStock?.address_owner?.district_name}
                                        </Col>
                                    </Row>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Kelurahan:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {this.state.dataDetailStock?.address_shipping?.sub_district_name
                                                ? this.state.dataDetailStock?.address_shipping?.sub_district_name
                                                : this.state.dataDetailStock?.address_owner?.sub_district_name}
                                        </Col>
                                    </Row>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Kode Pos:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {this.state.dataDetailStock?.address_shipping?.zip_code ? this.state.dataDetailStock?.address_shipping?.zip_code : this.state.dataDetailStock?.address_owner?.zip_code}
                                        </Col>
                                    </Row>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Alamat:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {this.state.dataDetailStock?.address_shipping?.full_address
                                                ? this.state.dataDetailStock?.address_shipping?.full_address
                                                : this.state.dataDetailStock?.address_owner?.full_address}
                                        </Col>
                                    </Row>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Point Lokasi:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {this.state.dataDetailStock?.address_shipping?.location_point?.point}
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                            <Col xl={12} lg={12} md={24} sm={24} xs={24}>
                                <Card style={{marginLeft: 20, marginRight: 20, marginTop: 10}} size="small"
                                      hoverable={true}>
                                    Data Pengiriman
                                    <Divider style={{marginTop: 10, marginBottom: 10}}/>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Nama Mediator:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {this.state.dataDetailStock?.data_shipping?.mediator_name}
                                        </Col>
                                    </Row>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Nomor Telpon Mediator:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {this.state.dataDetailStock?.data_shipping?.mediator_phone_number?.substring(0, 2) === "08"
                                                ? this.state.dataDetailStock?.data_shipping?.mediator_phone_number?.replace(/^.{2}/g, "628")
                                                : this.state.dataDetailStock?.data_shipping?.mediator_phone_number}
                                        </Col>
                                    </Row>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Uang yang diterima Mediator:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {currencyFormat(this.state.dataDetailStock?.data_shipping?.mediator_credit_amount ?? 0)}
                                        </Col>
                                    </Row>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Uang yang diambil di Konsumen:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {currencyFormat(this.state.dataDetailStock?.data_shipping?.customer_cash_on_delivery ?? 0)}
                                        </Col>
                                    </Row>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Tanggal Pengiriman:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {this.state.dataDetailStock?.data_shipping?.shipping_date}
                                        </Col>
                                    </Row>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Tanggal Jatuh Tempo:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {this.state.dataDetailStock?.data_shipping?.shipping_credit_payment_date}
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="Chat Ideal" key="8">
                        <Row>
                            <Col xs={24} xl={8} style={this.state.phoneNumberOwner ? {} : {display: "none"}}>
                                <ChatHistory
                                    onCloseProps={this.onPropsChat}
                                    time={Math.floor(+new Date() / 1000)}
                                    dataOffer={this.state.dataDetailStock}
                                    urlImageCatalogue={this.state.urlImageCatalogue}
                                    phoneNumber={this.state.phoneNumberOwner}
                                />
                            </Col>
                            <Col xs={24} xl={8}
                                 style={this.state.phoneNumberAlternative_owner && this.state.phoneNumberOwner !== this.state.phoneNumberAlternative_owner ? {} : {display: "none"}}>
                                <ChatHistory
                                    onCloseProps={this.onPropsChat}
                                    time={Math.floor(+new Date() / 1000)}
                                    dataOffer={this.state.dataDetailStock}
                                    urlImageCatalogue={this.state.urlImageCatalogue}
                                    phoneNumber={this.state.phoneNumberAlternative_owner}
                                />
                            </Col>
                            <Col
                                xs={24}
                                xl={8}
                                style={
                                    this.state.phoneNumberOrderMaker && this.state.phoneNumberOrderMaker !== this.state.phoneNumberOwner && this.state.phoneNumberOrderMaker !== this.state.phoneNumberAlternative_owner
                                        ? {}
                                        : {display: "none"}
                                }
                            >
                                <ChatHistory
                                    onCloseProps={this.onPropsChat}
                                    time={Math.floor(+new Date() / 1000)}
                                    dataOffer={this.state.dataDetailStock}
                                    urlImageCatalogue={this.state.urlImageCatalogue}
                                    phoneNumber={this.state.phoneNumberOrderMaker}
                                />
                            </Col>
                        </Row>
                    </Tabs.TabPane>
                </Tabs>

                <Modal
                    open={this.state.modalPo}
                    title={`Track Number ${this.state.dataDetailStock?.credit?.po_track_number}`}
                    onOk={() => this.setState({modalPo: false})}
                    onCancel={() => this.setState({modalPo: false})}
                    cancelText={"Tutup"}
                    okText={false}
                    footer={[
                        <Button key="back" type="primary" onClick={() => this.setState({modalPo: false})}>
                            Tutup
                        </Button>,
                    ]}
                >
                    <div style={this.state.fetchingPo ? {} : {display: "none"}} className={`spinCenter`}>
                        <Spin size="large"/>
                    </div>
                    <div style={!this.state.fetchingPo ? {} : {display: "none"}}>
                        <pre>{JSON.stringify(this.state.dataPo, undefined, 3)}</pre>
                    </div>
                </Modal>

                <Modal
                    open={this.state.showModalPrebooking}
                    title={`Detail Prebooking`}
                    onOk={() => this.setState({showModalPrebooking: false})}
                    onCancel={() => this.setState({showModalPrebooking: false})}
                    cancelText={"Tutup"}
                    okText={false}
                    footer={[
                        <Button key="back" type="default" onClick={() => this.setState({showModalPrebooking: false})}>
                            Tutup
                        </Button>,
                    ]}
                >
                    <DetailPrebooking companyCode={this.state.companyCode}
                                      prebookingCode={this.state.chosenPrebookingCode}
                                      time={Math.floor(+new Date() / 1000)}/>
                </Modal>
            </React.Fragment>
        );
    }
}

export default DetailOffer;